import { render } from "./ChatTab.vue?vue&type=template&id=3a2a32b8&scoped=true&ts=true"
import script from "./ChatTab.vue?vue&type=script&lang=ts"
export * from "./ChatTab.vue?vue&type=script&lang=ts"

import "./ChatTab.vue?vue&type=style&index=0&id=3a2a32b8&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2a32b8"]])

export default __exports__